module.exports = __webpack_public_path__ + "static/mocaco-case-study-1a7b2319e48873534e5b5a2391d204d1.webp";